import React from 'react';
import PropTypes from 'prop-types';
import styles from './EventTypeFields.module.scss';

import InputFieldErrorMessage from '../../../../common/components/InputFieldErrorMessage';

const EventTypeFields = ({
  eventType,
  eventTypes,
  locationType,
  onEventTypeChange,
  onLocationTypeChange,
  onEventTypeBlur,
}) => {
  return (
    <>
      <div className={styles['field-label']}>
        Event type <span className={styles.required}>*</span>
      </div>
      <div className={styles['event-type-container']}>
        <div className={styles['event-type-input']}>
          <select
            name="eventType"
            id="eventType"
            aria-label="Enter your event type"
            onChange={onEventTypeChange}
            onBlur={onEventTypeBlur}
            value={eventType.value}
          >
            <option value="" aria-label="No event type selected">Choose an option</option>
            {eventTypes.map((type) => {
              return (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              );
            })}
          </select>
          <InputFieldErrorMessage field={eventType} />
        </div>
        <div className={styles['radio-container']}>
          <fieldset>
            <label className={styles.label} htmlFor="location_online">
              <input
                type="radio"
                id="location_online"
                name="locationType"
                onChange={onLocationTypeChange}
                checked={locationType.value === 'ONLINE'}
                value="ONLINE"
              />
              Online
            </label>
            <label className={styles.label} htmlFor="location_in_person">
              <input
                type="radio"
                id="location_in_person"
                name="locationType"
                onChange={onLocationTypeChange}
                checked={locationType.value === 'IN_PERSON'}
                value="IN_PERSON"
              />
              In-person
            </label>
          </fieldset>
        </div>
      </div>
    </>
  );
};

EventTypeFields.propTypes = {
  eventType: PropTypes.shape({
    value: PropTypes.string,
    dirty: PropTypes.bool,
    error: PropTypes.string,
  }).isRequired,
  eventTypes: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  locationType: PropTypes.shape({
    value: PropTypes.string,
    dirty: PropTypes.bool,
    error: PropTypes.string,
  }).isRequired,
  onEventTypeChange: PropTypes.func.isRequired,
  onLocationTypeChange: PropTypes.func.isRequired,
  onEventTypeBlur: PropTypes.func.isRequired,
};

export default EventTypeFields;
